// ============================================================
// Jadwal tema otomatis — dark 18:00–06:00 (zona waktu lokal browser)
// ============================================================

export const THEME_STORAGE_KEY = 'uspatih_theme';
export const THEME_AUTO_KEY = 'uspatih_theme_auto';
export const DARK_START_HOUR = 18;
export const LIGHT_START_HOUR = 6;

/** @param {Date} [date] */
export function getScheduledTheme(date = new Date()) {
  const hour = date.getHours();
  return (hour >= DARK_START_HOUR || hour < LIGHT_START_HOUR) ? 'dark' : 'light';
}

export function isAutoThemeEnabled() {
  return localStorage.getItem(THEME_AUTO_KEY) !== 'false';
}

export function resolveTheme() {
  if (isAutoThemeEnabled()) {
    return getScheduledTheme();
  }
  return localStorage.getItem(THEME_STORAGE_KEY) || 'light';
}

/** Milidetik sampai pergantian tema berikutnya (untuk setTimeout) */
export function msUntilNextThemeChange(date = new Date()) {
  const next = new Date(date);
  const hour = date.getHours();

  if (hour >= DARK_START_HOUR) {
    next.setDate(next.getDate() + 1);
    next.setHours(LIGHT_START_HOUR, 0, 0, 0);
  } else if (hour < LIGHT_START_HOUR) {
    next.setHours(LIGHT_START_HOUR, 0, 0, 0);
  } else {
    next.setHours(DARK_START_HOUR, 0, 0, 0);
  }

  return Math.max(next.getTime() - date.getTime(), 60_000);
}
